import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../Components copy/assets/Images/congratsdoneimage.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { REDIRECTURL } from "../shared copy/constants";
import { useDispatch, useSelector } from "react-redux";
import routesData from "../shared copy/routes.json";
import styles from "./Styles/Redirect.module.scss";
// import HeaderComp from "../components/HeaderComp/HeaderComp";
import {
  digiLockerAuthenticationAPICall,
  esignDocumentAPICall,
} from "../shared copy/APICalls";

export default function SuccessAadhaarPage() {
  const [countDown, setCountDown] = useState(3);
  const [displayError, setDisplayError] = useState(false);
  const [loading, setloading] = useState(true);
  const [agentPlatform, setAgentPlatform] = useState("");
  const countdownIntervalRef = useRef<ReturnType<typeof setInterval> | null>(
    null,
  );
  const redirectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const pathName = useLocation().search;
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const code = params.id;
  const state = params.state;
  const setu_id = params.code;
  // console.log(urlParams,"urlParams",window.location.href );
  sessionStorage.setItem("access-token", state);

  const navigationData = routesData;
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.href.includes("Cancelled")) {
      // console.log("cancel");
      clearCountdownTimers();
      setloading(false);
      setDisplayError(true);
    } else {
      setDisplayError(false);
      senEsignDetails();
    }

    return () => {
      clearCountdownTimers();
    };
  }, []);

  function clearCountdownTimers() {
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }

    if (redirectTimeoutRef.current) {
      clearTimeout(redirectTimeoutRef.current);
      redirectTimeoutRef.current = null;
    }
  }

  function startRedirectCountdown(redirectUrl: string) {
    clearCountdownTimers();
    setCountDown(3);

    countdownIntervalRef.current = setInterval(() => {
      setCountDown((prevCountDown) => {
        if (prevCountDown <= 1) {
          if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
          }

          return 0;
        }

        return prevCountDown - 1;
      });
    }, 1000);

    redirectTimeoutRef.current = setTimeout(() => {
      //   window.location.href = redirectUrl;
      window.close();
    }, 3000);
  }

  function senEsignDetails() {
    let obj: any = {
      code: setu_id,
    };
    setloading(true);
    digiLockerAuthenticationAPICall(obj)
      .then((response: any) => {
        setloading(false);

        startRedirectCountdown(`${REDIRECTURL}congratulations`);
        // }
      })
      .catch((error: any) => {
        clearCountdownTimers();
        setloading(false);
        // if (agentPlatform === "iOS") {
        //   StageDetails();
        // } else {
        setTimeout(() => {
          window.close();
        }, 3000);
        // window.location.href = `${REDIRECTURL}esign`;
        // }

        setDisplayError(true);
      });
  }

  return (
    <>
      {/* <HeaderComp /> */}
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={DoneImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirected in ${countDown} seconds.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
